var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Purchase Orders"}},[_c('p-o-filters',{on:{"filtersUpdated":_vm.filtersChangeHandler}}),_c('purchase-orders-list',{attrs:{"filters":_vm.filters}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }